import { environment } from '@environment';

export const flightResultsApi = {
  air_search: `${environment.api.services}/api/travel-proxy-ms/air/v2/search`,
  air_search_by_sector: `${environment.api.services}/api/travel-proxy-ms/air/by-sector/search`,
  air_save_searches: `${environment.api.services}/api/ms/travel-searches/flights`,
  air_filter: `${environment.api.services}/api/travel-proxy-ms/air/filter?search_id={searchId}`,
  air_filter_by_sector: `${environment.api.services}/api/travel-proxy-ms/air/by-sector/filter`,
  air_option: `${environment.api.netactica}/AirGroupedResults?searchId={searchId}`,
  alliance_images: `${environment.api.images}/Airlines/{alliance}.png`,
  air_upsell: `${environment.api.netactica}/Air/Upsell/WholeTrip?searchId={searchId}&optionId={optionId}`,
  air_flex_dates: `${environment.api.netactica}/Air/FlexDates`,
  air_cabin_amenities: `${environment.api.travel_flight_content}/travel-flight-content/flight/results`,
  air_cabin_detail: `${environment.api.travel_flight_content}/travel-flight-content/flight/detail`,
  rappi_intermediary_payment: `${environment.api.services}/api/ms/sh-cart-intermediary/viajes/initialization`,
};
